import { takeEvery, call } from 'redux-saga/effects';
import { CHANGE_NAVIGATION } from '@corefront/redux-aba';
import { getHistory } from '../../../services/history';
import { ROOT } from '../../../constants/routeTemplates';

export function* changeNavigationWorker(action) {
  const history = yield call(getHistory);
  const targetRoute = action?.payload ?? ROOT;
  yield call([history, 'push'], targetRoute);
}

export function* changeNavigationWatcher() {
  yield takeEvery(CHANGE_NAVIGATION, changeNavigationWorker);
}
